<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="d12e80"><img alt="0310252342_content_0005_007" id="d12e81" src="images/0310252342_content_0005_007.jpg"/><b>To June Jordan </b><img alt="0310252342_content_0005_007" id="d12e85" src="images/0310252342_content_0005_007.jpg"/></p>
<p class="extc" id="d12e86"><i>The world is short of virtuous women,<br/>but there are a few left. You,<br/>June, are one of those<br/>wonderful examples of what<br/>a wife and mot her should be!</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morr_9780310252344_epub_c2y_r1.vue?6312ea26